<template>
  <section class="bg-white">
    <div class="card max-w-grid-width">
      <div class="card-body p-3">
        <div class="cardHeader">Ihre Anfrage</div>
        <div
          class="card-text pt-5"
          style="min-height: 100px; max-height: 600px; overflow: auto"
        >
          <div
            class="row text-start rundeEcken p-2 m-1"
            v-for="anfragenDetail in anfragen"
            v-bind:key="anfragenDetail.ID"
            v-bind:value="anfragenDetail.ID"
          >
            <div class="col-md-3">
              <img
                :src="getBild(anfragenDetail.name)"
                :alt="anfragenDetail.name"
                class="img-fluid AnfrageBild"
              />
            </div>
            <div class="col-md-3">
              <b> {{ getBezeichnung(anfragenDetail.name) }}</b> <br />

              <div
                class="input-group input-group-sm mb-1"
                v-if="anfragenDetail.masse && anfragenDetail.masse.laenge"
              >
                <span class="input-group-text masseFeld">Länge:</span>
                <input
                  type="number"
                  class="form-control"
                  style="max-width: 80px"
                  v-model="anfragenDetail.masse.laenge"
                />
                <span class="input-group-text">cm</span>
              </div>

              <div
                class="input-group input-group-sm mb-1"
                v-if="anfragenDetail.masse && anfragenDetail.masse.breite"
              >
                <span class="input-group-text masseFeld">Breite:</span>
                <input
                  type="number"
                  class="form-control"
                  style="max-width: 80px"
                  v-model="anfragenDetail.masse.breite"
                />
                <span class="input-group-text">cm</span>
              </div>

              <div
                class="input-group input-group-sm mb-1"
                v-if="anfragenDetail.masse && anfragenDetail.masse.hoehe"
              >
                <span class="input-group-text masseFeld">Höhe:</span>
                <input
                  type="number"
                  class="form-control"
                  style="max-width: 80px"
                  v-model="anfragenDetail.masse.hoehe"
                />
                <span class="input-group-text">cm</span>
              </div>
              <div
                class="input-group input-group-sm mb-1"
                v-if="anfragenDetail.masse && anfragenDetail.masse.staerkemm"
              >
                <span class="input-group-text">Stärke:</span>
                <input
                  type="number"
                  class="form-control"
                  style="max-width: 80px"
                  v-model="anfragenDetail.masse.staerkemm"
                />
                <span class="input-group-text">mm</span>
              </div>
              <div
                class="input-group input-group-sm mb-1"
                v-if="anfragenDetail.masse && anfragenDetail.masse.staerkemy"
              >
                <span class="input-group-text">Stärke:</span>
                <input
                  type="number"
                  class="form-control"
                  style="max-width: 80px"
                  v-model="anfragenDetail.masse.staerkemy"
                />
                <span class="input-group-text">my</span>
              </div>
              <div
                class="input-group input-group-sm mb-1"
                v-if="anfragenDetail.masse && anfragenDetail.masse.meter"
              >
                <span class="input-group-text">Meter:</span>
                <input
                  type="number"
                  class="form-control"
                  style="max-width: 80px"
                  v-model="anfragenDetail.masse.meter"
                />
                <span class="input-group-text">m</span>
              </div>
            </div>
            <div class="col-md-3">
              Ihr Bescheibung:
              <textarea
                class="form-control"
                v-model="anfragenDetail.beschreibung"
              ></textarea>
            </div>
            <div class="col-md-3">
              <div class="input-group input-group-sm mb-3">
                <span class="input-group-text">Anzahl</span>
                <input
                  type="number"
                  class="form-control"
                  style="width: 40px"
                  v-model="anfragenDetail.anzahl"
                />
                <button
                  class="btn btn-outline-danger"
                  type="button"
                  id="button-addon1"
                  @click="deleteItem(anfragenDetail)"
                >
                  -
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="contact_form pb-3 max-w-grid-width">
      <div class="row justify-content-center">
        <div class="col-md-12 pt-3">
          <div class="row justify-content-center whi">
            <div class="col-md-4"></div>
            <div class="col-md-6">
              <span class="required_notification">* notwendige Eingaben</span>
            </div>
          </div>
          <div class="row justify-content-center whi">
            <div class="col-md-10">
              <p>
                Wir melden uns so schnell wie möglich bei Ihnen zurück. Wenn Sie uns Ihre
                Telefonnummer verraten, auch auf diesem Weg.
              </p>
            </div>
          </div>
          <div class="row justify-content-center whi">
            <div class="col-md-6">
              <ul>
                <li>
                  <label class="textLabel" for="name">Firma:</label>
                  <input
                    type="text"
                    name="name"
                    class="formtextField"
                    placeholder="Firma"
                    v-model="mail.firma"
                  />
                </li>
                <li>
                  <label class="textLabel" for="name">Name:*</label>
                  <input
                    type="text"
                    name="name"
                    class="formtextField"
                    v-bind:class="background.name"
                    placeholder="Mein Name"
                    v-model="mail.name"
                  />
                </li>
                <li>
                  <label class="textLabel" for="email">Email:*</label>
                  <input
                    type="email"
                    name="email"
                    class="formtextField"
                    placeholder="max@example.de"
                    v-model="mail.email"
                    v-bind:class="background.email"
                  />
                  <p v-if="!isValidEmail && mail.email" class="text-danger">Ungültige E-Mail-Adresse</p>
                </li>

                <li>
                  <label class="textLabel" for="email">Telefon:</label>
                  <input
                    type="text"
                    name="telefon"
                    class="formtextField"
                    placeholder="0123 456789"
                    v-model="mail.telefon"
                  />
                </li>
              </ul>
            </div>

            <div class="col-md-6">
              <ul>
                <li>
                  <label class="textLabel" for="email">Message:</label><br />
                  <textarea
                    name="message"
                    rows="3"
                    class="form_message_Field"
                    v-model="mail.message"
                  >
                  </textarea>
                </li>

                <li>
                  <input
                    type="checkbox"
                    name="datenschutz"
                    class="checkbox"
                    v-model="mail.datenschutz"
                    v-bind:class="background.datenschutz"
                  />*<span
                    class="ps-5 checkboxLabel"
                    v-bind:class="background.datenschutz"
                    for="email"
                  >
                    Die Angaben zum
                    <router-link to="/Datenschutz" class="">Datenschutz</router-link>
                    habe ich gelesen .
                  </span>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="row justify-content-center whi">
          <div class="col-md-4 d-grid gap-2">
            <button class="submit m-0" type="submit" @click="sendMail()">
              Abschicken
            </button>
          </div>
        </div>
        <div class="row justify-content-center whi">
          <div class="col-md-4 d-grid gap-2">
            {{ mail.gesendet }}
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { closeModal } from "jenesius-vue-modal";
import { computed } from "vue";
import { anfragenStore } from "@/stores/AnfrageStore";
import axios from "axios";

  


export default {
  name: "ModalsKassenbuchungEdit",
  data() {
    return {
      newSite: null,
      visi: false,
      mail: {
        name: "",
        email: "",
        telefon: "",
        message: "",
        firma: "",
        datenschutz: false,
        gesendet: "",
      },
      background: {
        name: "",
        email: "",
        message: "",
        datenschutz: "",
      },
    };
  },
  setup() {
    const store = anfragenStore();
    const anfragen = computed(() => store.getItems);

    return {
      anfragen,
    };
  },
  computed: {
    isValidEmail() {
      const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return regex.test(this.mail.email);
    }
  },
  methods: {
    closeCookieDetail() {
      closeModal();
    },
    setCookie() {
      // Cookie setzen
      this.$cookies.set("HomepageCookiePillarSoft", this.$t("adresseName"));
      closeModal();
    },
    getBild(item) {
      if (item == "Europalette") {
        return "/images/balkenMitBildPaletten/Euro.png";
      } else if (item == "Kiste") {
        return "/images/balkenMitBildPaletten/Kiste.png";
      } else if (item == "KundenPalette") {
        return "/images/balkenMitBildPaletten/KundenPalette.png";
      } else if (item == "Verpackungen") {
        return "/images/balkenMitBildVerpackungen/Versandverpackungen.png";
      } else if (item == "Industrieverpackung") {
        return "/images/balkenMitBildVerpackungen/Industrieverpackungen.png";
      } else if (item == "Präsentverpackung") {
        return "/images/balkenMitBildVerpackungen/Geschenk.png";
      } else if (item == "Pharmazie-Verpackung") {
        return "/images/balkenMitBildVerpackungen/Pharmazie.png";
      } else if (item == "ESDVerpackung") {
        return "/images/balkenMitBildVerpackungen/Esd.png";
      } else if (item == "Verpackungszubehoer") {
        return "/images/balkenMitBildVerpackungen/Verpackungszubehoer.png";
      } else if (item == "Verpackungsmaschinen") {
        return "/images/balkenMitBildVerpackungen/Verpackungsmaschinen.png";
      } else if (item == "VerpackungszubehoerMaschinen") {
        return "/images/balkenMitBildVerpackungen/VerpackungszubehoerMaschinen.png";
      } else if (item == "Handstretchfolie") {
        return "/images/balkenMitBildFolien/Handstretchfolie.png";
      } else if (item == "Maschinenstretchfolie") {
        return "/images/balkenMitBildFolien/Maschinenfolie.png";
      } else if (item == "Polsterfolie") {
        return "/images/balkenMitBildPolstermaterial/Polsterfolie.png";
      } else if (item == "Klebeband") {
        return "/images/balkenMitBildZubehoer/Klebebaender.png";
      } else if (item == "Umreifungsband") {
        return "/images/balkenMitBildZubehoer/Umreifungsband.png";
      } else if (item == "Stahlband") {
        return "/images/balkenMitBildZubehoer/Stahlband.png";
      } else if (item == "Polsterchips") {
        return "/images/balkenMitBildPolstermaterial/Chips.png";
      } else if (item == "RollenWellpappe") {
        return "/images/balkenMitBildPolstermaterial/RollenWellpappe.png";
      } else if (item == "Packpapier") {
        return "/images/balkenMitBildPolstermaterial/Packpapier.png";
      } else if (item == "PEFolie") {
        return "/images/balkenMitBildPolstermaterial/PE-Folie.png";
      } else if (item == "Polsterschaum") {
        return "/images/balkenMitBildPolstermaterial/Polsterschaum.png";
      } else if (item == "Zuschnitte") {
        return "/images/balkenMitBildPolstermaterial/Zuschnitte.png";
      }
    },
    getBezeichnung(item) {
      if (item == "Europalette") {
        return "Europaletten";
      } else if (item == "Kiste") {
        return "Kisten";
      } else if (item == "KundenPalette") {
        return "Kundenspezifische Paletten";
      } else if (item == "Verpackungen") {
        return "Verpackungen";
      } else if (item == "Industrieverpackung") {
        return "Industrieverpackung";
      } else if (item == "Präsentverpackung") {
        return "Präsentverpackung";
      } else if (item == "Pharmazie-Verpackung") {
        return "Pharmazie-Verpackung";
      } else if (item == "ESDVerpackung") {
        return "ESD-Verpackung";
      } else if (item == "Verpackungszubehoer") {
        return "Verpackungszubehoer";
      } else if (item == "Verpackungsmaschinen") {
        return "Verpackungsmaschinen";
      } else if (item == "VerpackungszubehoerMaschinen") {
        return "Verpackungszubehoer Maschinen";
      } else if (item == "Handstretchfolie") {
        return "Handstretchfolie";
      } else if (item == "Maschinenstretchfolie") {
        return "Maschinenstretchfolie";
      } else if (item == "Polsterfolie") {
        return "Polsterfolie";
      } else if (item == "Klebeband") {
        return "Klebeband";
      } else if (item == "Umreifungsband") {
        return "Umreifungsband";
      } else if (item == "Stahlband") {
        return "Stahlband";
      } else if (item == "Polsterchips") {
        return "Polsterchips";
      } else if (item == "RollenWellpappe") {
        return "Rollen-Wellpappe";
      } else if (item == "Packpapier") {
        return "Packpapier";
      } else if (item == "PEFolie") {
        return "PE-Folie";
      }
    },

    deleteItem(anfragenDetail) {
      const store = anfragenStore();
      store.delItem(anfragenDetail);
    },

 

    checkEingaben() {
      let re = true;
      if (this.mail.name == "") {
        this.background.name = "border border-2 border-danger";
        re = false;
      } else {
        this.background.name = "border border-2 border-success";
      }
      if (this.mail.email == "") {
        this.background.email = "border border-2 border-danger";
        re = false;
      } else {
        this.background.email = "border border-2 border-success";
      }
      if (this.mail.datenschutz == false) {
        this.background.datenschutz = "bg-danger";
        re = false;
      } else {
        this.background.datenschutz = "bg-success";
      }

      return re;
    },
    sendMail() {
      if (this.checkEingaben()) {
        const axiosConfig = {
          headers: {
            Accept: "text/plain",
            "Content-Type": "text/plain",
          },
        };

        let anfragen = this.anfragen;
        let artikel = "Artikel:  ";

        artikel += `<table border="1" cellpadding="5" cellspacing="0" style="border-collapse: collapse; width: 100%;">
<thead><tr>
  <th>Anzahl</th><th>Name</th><th>Breite (cm)</th><th>Länge (cm)</th><th>Länge (m)</th>
  <th>Stärke (mm)</th><th>Stärke (my)</th><th>Höhe (cm)</th><th>Beschreibung</th>
</tr></thead><tbody>`;

        for (let i = 0; i < anfragen.length; i++) {
          let a = anfragen[i];
          artikel += `<tr>
    <td>${a.anzahl}</td>
    <td>${a.name}</td>
    <td>${a.masse?.breite ?? ""}</td>
    <td>${a.masse?.laenge ?? ""}</td>
    <td>${a.masse?.meter ?? ""}</td>
    <td>${a.masse?.staerkemm ?? ""}</td>
    <td>${a.masse?.staerkemy ?? ""}</td>
    <td>${a.masse?.hoehe ?? ""}</td>
    <td>${a.beschreibung ?? ""}</td>
  </tr>`;
        }

        artikel += "</tbody></table>";

        const payload = {
          //empfaenger: "joerg@pillar.de",
          empfaenger: "info@thuepack.de",
          name: this.mail.name,
          telefon: this.mail.telefon,
          firma: this.mail.firma,
          email: this.mail.email,
          text: this.mail.message,
          datenschutz: this.mail.datenschutz,
          anfragen: artikel,
        };
        let mail = this.mail;
        let background = this.background;
        axios
          .post("https://pillar.de/mailrelay/post_attachment.php", payload, axiosConfig)
          .then((response) => {
            console.log("success", response.data);
            mail.gesendet = "Ihre Anfrage wurden erfolgreich versendet";
            mail.name = "";
            background.name = "";
            mail.email = "";
            background.email = "";
            mail.message = "";
            background.message = "";
            mail.datenschutz = false;
            background.datenschutz = "";
            mail.telefon = "";
            mail.firma = "";

            const store = anfragenStore();
            store.clearItems();
          })
          .catch((error) => {
            console.log(error.response);
            mail.gesendet =
              "Ihre Kontaktdaten konnten leider nicht gesendet werden. Bitte rufen Sie uns an.";
          });
      }
    },
  },
};
</script>

<style scoped>
@media (max-width: 576px) {
  /* SM */
  .form_message_Field {
    width: 290px;
  }
}
@media (min-width: 576px) {
  /* SM */
  .form_message_Field {
    width: 290px;
  }
}
@media (min-width: 768px) {
  /* MD */
  .form_message_Field {
    width: 350px;
  }
}
@media (min-width: 992px) {
  /* LG */
  .form_message_Field {
    width: 350px;
  }
}
@media (min-width: 1200px) {
  /* XL */
  .form_message_Field {
    width: 450px;
  }
}
</style>
